"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Link = _interopRequireDefault(require("../../Link/Link"));
var _ComponentWrapper = _interopRequireDefault(require("../../helpers/ComponentWrapper"));
var FooterBar = function FooterBar(_ref) {
  var links = _ref.links,
    address = _ref.address;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "footer--bar d8-u-color-white d8-u-primary-bg"
  }, /*#__PURE__*/_react["default"].createElement(_ComponentWrapper["default"], null, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-column flex-row@sm justify-between"
  }, /*#__PURE__*/_react["default"].createElement("nav", {
    className: "bar--links flex flex-column flex-row@sm grid-gap-md"
  }, /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, links.map(function (link) {
    return /*#__PURE__*/_react["default"].createElement(_Link["default"], {
      key: JSON.stringify(link),
      className: "d8-u-color-white d8-u-text-bold text-sm",
      href: link.href,
      external: link.externalLink
    }, link.label);
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bar--social-links flex"
  }, address && /*#__PURE__*/_react["default"].createElement("p", {
    className: "text-sm margin-top-md margin-top-0@sm"
  }, address)))));
};
FooterBar.propTypes = {
  links: _propTypes["default"].arrayOf(_propTypes["default"].object),
  address: _propTypes["default"].string
};
var _default = exports["default"] = FooterBar;